import { BreachEvent } from '@news-mono/web-common'
import React from 'react'
import { MessageBannerSmall } from '../../../../../banners/MessageBannerSmall/MessageBannerSmall'
import { VideoTrailerCard } from '../../../../../cards/VideoTrailerCard/VideoTrailerCard'
import { packageOfferDetails } from '../../../common'
import { BreachWallContentType } from '../BreachNotificationWrapper'
import { WestRewardsMessage } from '../shared-components/WestRewardsMessage/WestRewardsMessage'
import BreachWallContent from './BreachWallContent/BreachWallContent'
import {
    StyledLiveTrailerWrap,
    StyledMessage,
    StyledTerms,
    StyledTitle,
} from './BreachWallContent/BreachWallContent.styled'

export interface BreachNotificationProps {
    breachCreativeName: string
    breachDeal: string
    onEvent: (event: BreachEvent) => void
    type: BreachWallContentType
    // Optional properties that can be passed on a per-campaign basis
    contentOptions?: {
        [key: string]: any
    }
}

export function BreachNotification({
    breachDeal,
    breachCreativeName,
    onEvent,
    contentOptions,
    type,
}: BreachNotificationProps) {
    const shouldShowLiveSportsTrailer =
        contentOptions && contentOptions.showLiveSportTrailer

    const is50percentOffDeal =
        breachDeal === 'COVIDDIG' || breachDeal === 'GOVAN50'

    const subscriptionPackages = packageOfferDetails(type)

    return (
        <div data-testid="BreachScreen">
            <MessageBannerSmall
                icon="subscriber"
                onEvent={onEvent}
            >
                <p>
                    Subscribers with digital access can view this article.
                </p>
            </MessageBannerSmall>

            <BreachWallContent
                breachCreativeName={breachCreativeName}
                breachDeal={breachDeal}
                onEvent={onEvent}
                title={() => {
                    if (is50percentOffDeal) {
                        return (
                            <React.Fragment>
                                <StyledTitle>Limited Offer</StyledTitle>
                                <StyledMessage>
                                    <p>Save over 50% for 8 weeks*</p>
                                </StyledMessage>
                            </React.Fragment>
                        )
                    }

                    return (
                        <React.Fragment>
                            <StyledTitle>Subscribe today.</StyledTitle>
                            <StyledMessage>
                                <p>
                                    Get unlimited access to award-winning journalism
                                    from Western Australia’s biggest newsroom.
                                </p>
                            </StyledMessage>
                        </React.Fragment>
                    )
                }}
                terms={() => {
                    if (is50percentOffDeal) {
                        return (
                            <StyledTerms>
                                *Valid for new subscribers only.
                                {` ${breachDealTerms(breachDeal)}`}
                                <br />
                                T&Cs apply
                            </StyledTerms>
                        )
                    }

                    return null
                }}
                mediaBanner={() => {
                    if (shouldShowLiveSportsTrailer) {
                        return (
                            <StyledLiveTrailerWrap>
                                <VideoTrailerCard
                                    layoutMode="double"
                                    onEvent={() => null}
                                />
                            </StyledLiveTrailerWrap>
                        )
                    }
                    return null
                }}
                subscriptionPackages={subscriptionPackages}
            />
        </div>
    )
}

function breachDealTerms(deal: string) {
    switch (deal) {
        case 'GOVAN50':
            return 'Offer ends 20 February 2021.'
        case 'BRE1DISC':
            return 'Offer ends 2 May 2021.'
        default:
            return ''
    }
}
